import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useFormik } from "formik";
import { usePaketeValidation } from "../../Components/Validation/use_Pakete";
import { useToast } from "../../Hooks/useToast";
import { FetchCreatePackeges } from "../../Apis/Package/Package";
import imageCompression from "browser-image-compression";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";

import FormikAutocompleteChips from "../../Components/Utils/Formik_Autocomplete";
import AlternativeHeader from "../../Components/Headres/Alternative_Header";
import FromikTextField from "../../Components/Utils/Formik_Texfiled";
import CustomButton from "../../Components/Utils/Custom_Btn";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const VisuallyHiddenInput = (props) => (
  <input style={{ display: "none" }} {...props} />
);

const AddEditPakete = () => {
  const durationOptions = [
    { label: "30 Minuten", value: 30 },
    { label: "1 Stunde", value: 60 },
    { label: "1.30 Stunden", value: 90 },
    { label: "2 Stunden", value: 120 },
    { label: "2.30 Stunden", value: 150 },
    { label: "3 Stunden", value: 180 },
    { label: "3.30 Stunden", value: 210 },
    { label: "4 Stunden", value: 240 },
    { label: "4.30 Stunden", value: 270 },
    { label: "5 Stunden", value: 300 },
    { label: "5.30 Stunden", value: 330 },
    { label: "6 Stunden", value: 360 }
  ];
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const { toastSuccess, toastError } = useToast();

  const navigate = useNavigate();
  const { formValidation } = usePaketeValidation();

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
        if (file) {
          try {
            const options = {
              maxSizeMB: 1,
              maxWidthOrHeight: 1024,
              useWebWorker: true,
            };
    
            const compressedFile = await imageCompression(file, options);
            setSelectedImage(compressedFile);
            setImagePreview(URL.createObjectURL(compressedFile));
          } catch (error) {
            toastError("Bildkomprimierung fehlgeschlagen.");
          }
        }
      };

  const formik = useFormik({
    initialValues: {
      name: "",
      duration: "",
      price: "",
      servicesList: [],
      longDescription: "",
      priceInDayOff:""
    },
    validationSchema: formValidation,
    onSubmit: async (values) => {
      try {
        setLoading(true);

        const formData = new FormData();
        formData.append("name", values.name);
        formData.append("duration", values.duration);
        formData.append("price", values.price);
        formData.append("priceInDayOff", values.priceInDayOff);
        formData.append("longDescription", values.longDescription);

        values.servicesList.forEach((service, index) => {
          formData.append(`servicesList[${index}]`, service);
        });

        formData.append("image", selectedImage);

        const result = await FetchCreatePackeges(formData);
        if (result?.status === 201) {
          toastSuccess("Das Paket wurde erfolgreich erzeugt!");
          navigate("/Pakete");
        } else {
          toastError("Die Erstellung des Pakets ist fehlgeschlagen.");
        }
      } catch (error) {
        toastError("Während der Übermittlung ist ein Fehler aufgetreten.");
      } finally {
        setLoading(false);
      }
    }
  });

  const isFormValid = Object.values(formik.values).every(
    (val) => val !== "" && val !== null && val !== undefined
  );

  return (
    <Box ml={2} component="form" onSubmit={formik.handleSubmit}>
      <AlternativeHeader
        onPrevious={() => navigate("/Pakete")}
        title="Neues Paket erstellen"
      />

      <Box mt={6}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 4 }}>
            <FromikTextField
              formik={formik}
              name="name"
              label="Paketname"
              placeholder="Paketname"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <FromikTextField
              formik={formik}
              name="duration"
              label="Dauer"
              select
            >
              {durationOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </FromikTextField>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <FromikTextField
              formik={formik}
              name="price"
              label="Preis"
              placeholder="z. B. 99.99"
              type="number"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <FromikTextField
              formik={formik}
              name="priceInDayOff"
              label="Preis am freien Tag"
              placeholder="z. B. 99.99"
              type="number"
            />
          </Grid>

          <Grid size={12}>
            <FormikAutocompleteChips
              formik={formik}
              name="servicesList"
              label="Services"
              placeholder="Service hinzufügen"
            />
          </Grid>

          <Grid
            sx={{ display: "flex", flexDirection: "column" }}
            size={12}
          >
            <Box
              sx={{
                display: "flex",
                width: { md: "200px" },
                height: { xs: "300px", md: "200px" },
                border: "2px solid #D6B981",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                borderRadius: "12px"
              }}
            >
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="preview"
                  style={{
                    width: "90%",
                    height: "90%",
                    objectFit: "cover"
                  }}
                />
              ) : (
                <Typography variant="body2" color="textSecondary">
                  Kein Bild hochgeladen
                </Typography>
              )}
            </Box>

            <Button
              sx={{ mt: 3, width: { md: "19%" } }}
              component="label"
              variant="contained"
              style={{ backgroundColor: "#D6B981" }}
              startIcon={<CloudUploadIcon />}
            >
              Bild hochladen
              <VisuallyHiddenInput
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
              />
            </Button>
          </Grid>

          <Grid size={12}>
            <FromikTextField
              formik={formik}
              name="longDescription"
              label="Beschreibung"
              placeholder="1-Notizen\n2-Notizen\n3-Notizen"
              multiline
              rows={4}
            />
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ mt: 4, bgcolor: "#000000" }} />

      <Box mt={2} display="flex" justifyContent="flex-end">
        <CustomButton
          onNavigate={formik.handleSubmit}
          title="speichern"
          disabled={loading}
        />
      </Box>
    </Box>
  );
};

export default AddEditPakete;
